import React from 'react';
import styled from 'styled-components';
import moment from 'moment';

import icModifyStyle from '../icons/ic-modify-style.svg';
import icModifyContent from '../icons/ic-modify.svg';
import icTrash from '../icons/ic-trash.svg';
import icCodeCopy from '../icons/ic-code-copy.svg';
import isMagnageContent from '../icons/ic-manageContent.svg';
import { ReactComponent as NextIcon } from '../icons/ic-next.svg';
import { Link, useHistory } from 'react-router-dom';

function MyContents(props) {
  const {
    title,
    completeYn,
    date,
    productCount,
    handleCodeCopy,
    thumbnail,
    openDeleteModal,
    handleModifyContents,
    handleModifyDesign,
    handleSetContents,
    contentsType,
    style,
    isPcPublished,
    isMobilePublished,
    isPosted,
    isPublishedContent,
  } = props;

  const history = useHistory();

  const buttonText =
    completeYn === 1
      ? isPosted//(isPcPublished || isMobilePublished)
        ? '게시하기'
        : '쇼핑몰에 게시하기'
      : '콘텐츠 완성하러 가기';

  const clickHandler = () => {
    if (completeYn === 1) {
      handleSetContents();
    } else {
      handleModifyContents();
    }
  };

  return (
    <div
      className="my-contents"
      style={{
        width: 381.8,
        height: 214.76,
        borderRadius: 5,
        backgroundImage: `url(${thumbnail}) `,
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'cover',
      }}
    >
      {handleSetContents && (
        <div
          className="my-contents-buttons"
          style={{
            width: 381.8,
            height: 214.76,
            padding: 20,
            borderRadius: 5,
            display: 'flex',
            position: 'absolute',
            alignItems: 'flex-end',
            justifyContent: 'space-between',
          }}
        >
          <ContentHandleButton
            completeYn={completeYn}
            onClick={clickHandler}
            disabled={isPcPublished && isMobilePublished}
          >
            <span
              style={{
                height: 24,
              }}
            >
              {buttonText}
            </span>
            {<NextIcon stroke="white" strokeWidth="2" />}
          </ContentHandleButton>
          {isPosted && (//(isMobilePublished || isPcPublished) && (
            <ContentHandleButton
              ContentHandleButton
              completeYn={completeYn}
              onClick={() =>
                history.push({
                  pathname: '/mypage/posted-contents-management',
                })
              }
              disabled={!isPublishedContent}
            >
              <span
                style={{
                  height: 24,
                }}
              >
                {'게시 관리'}
              </span>
              <NextIcon stroke="white" strokeWidth="2" />
            </ContentHandleButton>
          )}

          <div style={{ display: 'flex', gap: 6 }}>
            <div className="icon-button-container">
              <IconButton onClick={handleModifyContents}>
                <img src={icModifyContent} alt="콘텐츠 수정하기" />
              </IconButton>
              <p
                className="icon-description"
                style={{
                  fontSize: '10px',
                  textAlign: 'center',
                  marginTop: '2px',
                  color: '#ffffff',
                  whiteSpace: 'nowrap',
                }}
              >
                콘텐츠 편집
              </p>
            </div>
            <div className="icon-button-container">
              <IconButton onClick={openDeleteModal}>
                <img src={icTrash} alt="콘텐츠 삭제하기" />
              </IconButton>
              <p
                className="icon-description"
                style={{
                  fontSize: '10px',
                  textAlign: 'center',
                  marginTop: '2px',
                  color: '#ffffff',
                  whiteSpace: 'nowrap',
                }}
              >
                콘텐츠 삭제
              </p>
            </div>
          </div>
        </div>
      )}
      <div
        style={{
          height: 214.76,
          borderRadius: 5,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          marginBottom: 10,
          backgroundColor: 'rgba(0, 0, 0, 0.5)',
          padding: 14,
        }}
      >
        <div
          style={{
            width: 341.8,
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            justifyContent: 'space-between',
          }}
        >
          <p
            style={{
              fontSize: 20,
              fontWeight: 700,
              color: 'white',
            }}
          >
            {title}
          </p>
          <p
            style={{
              fontSize: 16,
              fontWeight: 700,
              marginLeft: 'auto',
              color: completeYn === 1 ? '#FF7A00' : '#B5B5B5',
            }}
          >
            {completeYn === 1 ? '⦁ 완성' : '⦁ 미완성'}
          </p>
        </div>

        <hr
          style={{
            width: 380,
            height: 0,
            textAlign: 'center',
            marginTop: 12.45,
            color: 'white',
          }}
        />
        <div
          style={{
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            marginTop: 7,
          }}
        >
          <div
            style={{
              width: 341.8,
              display: 'flex',
              flexDirection: 'row',
              alignItems: 'center',
            }}
          >
            <p
              style={{
                fontSize: 12,
                fontWeight: 400,
                color: 'rgba(255, 255, 255, 0.7)',
              }}
            >
              {moment(date).format('YYYY.MM.DD')}
            </p>
            <p
              style={{
                fontSize: 12,
                fontWeight: 500,
                color: '#fff',
                marginLeft: 8.12,
              }}
            >
              태그상품 {productCount}개
            </p>
          </div>
        </div>
        {isMobilePublished || isPcPublished && contentsType && (
          <div
            style={{
              width: 341.8,
              display: 'flex',
              flexDirection: 'row',
              alignItems: 'center',
              marginTop: 'auto',
            }}
          >
            <div
              style={{
                width: 55,
                height: 29,
                borderRadius: 10,
                backgroundColor: '#605F5F',
                opacity: 0.7,
                color: '#FFFFFF',
                fontSize: 14,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              {contentsType}
            </div>

            <div
              style={{
                width: 85,
                height: 29,
                borderRadius: 10,
                backgroundColor: '#605F5F',
                opacity: 0.8,
                color: '#FFFFFF',
                fontSize: 14,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                marginLeft: 10,
              }}
            >
              {style}
            </div>
          </div>
        )}
        <div
          style={{
            width: '100%',
            display: 'flex',
            color: '#FFB600',
            textShadow: '0px 0px 8px rgba(0, 0, 0, 0.25)',
            fontSize: 12,
            fontWeight: 600,
            marginLeft: 10,
            marginTop: 6
          }}
        >
          {completeYn === 1 &&
            handleSetContents &&
            (
              isPosted && !isPcPublished && !isMobilePublished
                ? 'PC 및 모바일 미배치'
                : (isPcPublished && 'PC 배치 완료') ||
                (isMobilePublished ? '모바일 배치 완료' : '')
            )
          }
          {/* <p style={{ width: 10 }}></p>
          {completeYn === 1 &&
            handleSetContents &&
            isMobilePublished && ('모바일 배치 완료')
          } */}

        </div>
      </div>
    </div >
  );
}

export default MyContents;

const IconButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 34px;
  height: 34px;
  border-radius: 5px;
  border: 1px solid #b5b5b5;
  background: #fff;
  cursor: pointer;
`;

const ContentHandleButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 5px 14px;
  border-radius: 18.6px;
  background-color: ${(props) =>
    props.disabled
      ? '#B5B5B5'
      : props.completeYn === 1
        ? '#FF7A00'
        : '#FFB600'};
  color: #fff;
  font-size: 16px;
  font-weight: 600;
  border: none;
  cursor: ${(props) => (props.disabled ? 'default' : 'pointer')};
  margin-right: 20px;
`;
